/** @format */

import React from "react";
import { AppLoader } from "./app/appTheme";

const Loader = () => <AppLoader label='Loading search index' />;

export default Loader;
